import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/fila`

    return {
        paciente: {
            autocomplete(queryParms = {}) {

                return repository.post(`${baseUrl}/autocomplete-paciente`, queryParms)
            }
        },
        cid: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-cid?${urlUtil.serialize(queryParms)}`)
            }
        },
        ciap: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-ciap?${urlUtil.serialize(queryParms)}`)
            }
        },
        datatable(queryParms = {}) {

            return repository.post(`${baseUrl}/datatable`, queryParms)
        },
        list(params) {

            return repository.post(`${baseUrl}/list`, params)
        },
        getImpressoes(queryParms = {}) {

            return repository.get(`${baseUrl}/impressao?${urlUtil.serialize(queryParms)}`)
        },
        getTentativasContato(queryParms = {}) {

            return repository.get(`${baseUrl}/tentativa-contato?${urlUtil.serialize(queryParms)}`)
        },
        editProtocoloAgendamento(solicitacaoId) {

            return repository.get(`${baseUrl}/protocolo-agendamento/${solicitacaoId}/edit`)
        },
        updateProtocoloAgendamento(solicitacaoId, params) {

            return repository.put(`${baseUrl}/protocolo-agendamento/${solicitacaoId}`, params)
        },
        editPrioridade(solicitacaoId) {

            return repository.get(`${baseUrl}/prioridade/${solicitacaoId}/edit`)
        },
        updatePrioridade(solicitacaoId, params) {

            return repository.put(`${baseUrl}/prioridade/${solicitacaoId}`, params)
        },
        createTentativaContato(solicitacaoId, queryParms) {

            return repository.get(`${baseUrl}/tentativa-contato/${solicitacaoId}?${urlUtil.serialize(queryParms)}`)
        },
        storeTentativaContato(params) {

            return repository.post(`${baseUrl}/tentativa-contato`, params)
        },
        createOci(solicitacaoId) {

            return repository.get(`${baseUrl}/oci/${solicitacaoId}`)
        },
        storeOci(solicitacaoId, params) {

            return repository.post(`${baseUrl}/oci/${solicitacaoId}`, params)
        },
        updatePaciente(pacienteId, params) {

            return repository.put(`${baseUrl}/paciente/${pacienteId}`, params)
        },
        editSolicitacao(solicitacaoId, queryParms = {}) {

            return repository.get(`${baseUrl}/${solicitacaoId}/edit-solicitacao?${urlUtil.serialize(queryParms)}`)
        },
        updateSolicitacao(solicitacaoId, params) {

            return repository.put(`${baseUrl}/solicitacao/${solicitacaoId}`, params)
        },
        getDadosAmbulatorio(solicitacaoId) {

            return repository.get(`${baseUrl}/dados-ambulatorio/${solicitacaoId}`)
        },
        getDadosOci(solicitacaoId) {

            return repository.get(`${baseUrl}/dados-oci/${solicitacaoId}`)
        },
        getSolicitacaoFromDatatable(solicitacaoId) {

            return repository.get(`${baseUrl}/solicitacao-from-datatable/${solicitacaoId}`)
        },
        getAtendimentos(queryParms = {}) {

            return repository.get(`${baseUrl}/atendimento?${urlUtil.serialize(queryParms)}`)
        },
        updateSolicitacoes(params) {

            return repository.put(`${baseUrl}/solicitacoes`, params)
        },
    }
}